export default __webpack_public_path__ + "static/media/cesg.23095b0b.png";